import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import { WEBSITE_ANALYSIS_WIDGET_NAMES } from "app/pages/sales-intelligence/pages/company-analysis/constants";
import WWOTrafficVisitsOverTime from "app/pages/website-performance/components/TrafficVisitsOverTime/WWOTrafficVisitsOverTime";
import { DEFAULT_HOOKS_MODAL_ID } from "app/pages/workspace/config/stateToWsConfigMap";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const WWOTrafficVisitsOverTimeContainerSI = ({ hideFooter = false }: { hideFooter?: boolean }) => {
    const getCtaLink = (params) => {
        return {
            href: proNavigator.href("accountreview_website_trafficandengagement", params),
            target: "_self",
            onClick: () => {
                companyAnalysisTrackingService.website.trackWidgetCtaClick(
                    WEBSITE_ANALYSIS_WIDGET_NAMES.visitsOverTime,
                    params.key,
                );
            },
        };
    };
    return (
        <WWOTrafficVisitsOverTime
            getCtaLink={getCtaLink}
            unlockHook={{
                component: "WsWebTrafficAndEngagement",
                hookModal: DEFAULT_HOOKS_MODAL_ID,
            }}
            hideFooter={hideFooter}
        />
    );
};
